import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { AddClientDispatcher } from "./Variable";
import { Prospect } from "../../../../../../Wrap/Models/Models/Customer/Prospect";
import { ProspectClient } from "../../../../../../Wrap/Api/Customer/Prospect";

export interface AdviserWizardStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: Prospect;
}

export class AddClientStoreStatic extends BaseStore<AdviserWizardStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AddClientDispatcher, (actionData) =>
            this.onAddClientStoreResponse(actionData)
        );
    }

    public getLastResult(): AdviserWizardStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): AdviserWizardStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onAddClientStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
